import {
  IMPROVED_GROUP_VIEW_FEATURE_FLAG,
  RenderIfFFEnabled,
} from 'featureFlags';
import { Flex as FlexNew, Show } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import {
  GoalBadge,
  GoalTitle,
  GoalBackButton,
  GoalEditButton,
  GoalDeleteButton,
  GoalImage,
  useEditGoal,
  IGoal,
  IGoal__DEPRECATED,
} from 'features/goal';
import { usePrioritizeToggle } from 'features/goal/hooks/usePrioritizeToggle';
import { LifeDimensions } from 'features/lifeDimensions/components/LifeDimensions';

import { Createdat } from './Createdat';
import { GoalHeaderPrioritizedBadge } from './Header/PrioritizedBadge';
import { GoalPrioritizeToggle } from './PrioritizeToggle';

type TGoalHeader = {
  goal: IGoal | IGoal__DEPRECATED;
};

export const GoalHeader = ({ goal }: TGoalHeader) => {
  const {
    goalId,
    columnId,
    columnLabel,
    name,
    dimensions,
    deadline,
    createdAt,
    completedAt,
    cover,
    prioritizedAt,
  } = goal!;

  const togglePrioritize = usePrioritizeToggle();

  const { onEditGoalClick } = useEditGoal({ goal: goal! });

  return (
    <Flex
      as="header"
      justifyContent="space-between"
      width="100%"
      alignItems="center"
      dataTestid="goal-header"
    >
      <Flex flexDirection="column" alignItems="flex-start" width="100%">
        <GoalBackButton />
        <Flex width="100%" alignItems="center" justifyContent="space-between">
          <Flex>
            <Spacer size="lg lg zr zr">
              <GoalImage size="md" imageUrl={cover?.url} />
            </Spacer>
            <Flex
              flexDirection="column"
              alignItems="flex-start"
              height="100%"
              gap="0.5rem 0"
            >
              <GoalTitle title={name} />
              <LifeDimensions dimensions={dimensions} />
              {createdAt ? <Createdat createdAt={createdAt} /> : ''}
              <FlexNew alignItems="center" gap="var(--spacing02)" h={6}>
                <GoalBadge
                  deadline={deadline}
                  years={columnLabel}
                  completedAt={completedAt}
                />
                <RenderIfFFEnabled
                  featureFlag={IMPROVED_GROUP_VIEW_FEATURE_FLAG}
                >
                  <Show when={prioritizedAt}>
                    <GoalHeaderPrioritizedBadge />
                  </Show>
                </RenderIfFFEnabled>
              </FlexNew>
            </Flex>
          </Flex>
          <FlexNew alignItems="center" gap="var(--spacing04)">
            <RenderIfFFEnabled featureFlag={IMPROVED_GROUP_VIEW_FEATURE_FLAG}>
              <GoalPrioritizeToggle
                goalId={goalId}
                isPrioritized={!!prioritizedAt}
                size="md"
                togglePrioritize={togglePrioritize}
              />
            </RenderIfFFEnabled>
            <GoalEditButton onClick={onEditGoalClick} />
            <GoalDeleteButton goalId={goalId} columnId={columnId} />
          </FlexNew>
        </Flex>
      </Flex>
    </Flex>
  );
};
